import React from 'react';
import { useQuizContext } from '../../../../context/QuizContext';
import AnswerChoice from '../../AnswerChoice';
import { MultipleChoiceData } from '../../../../types/quiz';
import { QuizContainer } from '../../QuizContainer';
import LearnifyText from '../../../learn/LearnifyText';

/**
 * MultipleChoice component for quiz.
 */
const MultipleChoice = () => {
  const { currentItem, isAnswered } = useQuizContext();
  const showLearnifyLinks = true;

  const question = (currentItem?.data as MultipleChoiceData).question || '';

  return (
    <QuizContainer>
      <LearnifyText
        text={question}
        enabled={isAnswered && showLearnifyLinks}
        style={{ lineHeight: 1.5, textAlign: 'justify' }}
      />
      <AnswerChoice />
    </QuizContainer>
  );
};

export default MultipleChoice;
